import { render, staticRenderFns } from "./AdditionalBookingModal.vue?vue&type=template&id=f3b01402"
import script from "./AdditionalBookingModal.vue?vue&type=script&lang=js"
export * from "./AdditionalBookingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports